import classNames from "classnames";
import React, { Attributes, HTMLAttributes, ReactNode } from "react";

import { Button, Highlighter, Switch, Wrapper } from "./ButtonSwitch.styled";
import { ButtonProps } from "../Button";

export type ButtonSwitchProps = HTMLAttributes<HTMLDivElement> & {
  // /**
  //  * Child component <ButtonSwitch.Button>
  //  */
  children: ReactNode[];

  /**
   * Current active key, will be used to highlight button with same key
   */
  active?: string;
};

const defaultProps: ButtonSwitchProps = {
  children: []
};

const ButtonSwitchComp = React.forwardRef<HTMLDivElement, ButtonSwitchProps>((props, ref) => {
  const { active, children, className, ...resProps } = props;
  const buttonClass = classNames("c-button-switch", className);

  function isActive(active: string, children: (ReactNode & Attributes)[]) {
    const index = children.findIndex((item) => item.key === active);
    return index > -1 ? index : 0;
  }

  function renderOneButton({ props: childProps, key }: Attributes & { props: ButtonProps }) {
    return (
      <Switch
        data-testid="qa-button-switch"
        className={`c-button-switch__button ${key === active ? "is-active" : ""}`}
        type="button"
        key={key}
        active={key === active}
        disabled={childProps.disabled}
        onClick={childProps.onClick}
        {...childProps}
      >
        {childProps.children}
      </Switch>
    );
  }

  function renderButtons() {
    return children.map((child) => renderOneButton(child as Attributes & { props: ButtonProps }));
  }

  return (
    <Wrapper data-testid="qa-button-switch-wrapper" className={buttonClass} ref={ref} {...resProps}>
      <Highlighter
        data-testid="qa-button-switch-highlighter"
        className="c-button-switch__highlighter"
        active={isActive(active, children)}
        length={children.length}
      />
      {renderButtons()}
    </Wrapper>
  );
});

const ButtonSwitch = Object.assign(ButtonSwitchComp, {
  defaultProps,

  Button
});

export default ButtonSwitch;
